import { render, staticRenderFns } from "./ProveedorSMTP.vue?vue&type=template&id=35d27335&scoped=true"
import script from "./ProveedorSMTP.vue?vue&type=script&lang=js"
export * from "./ProveedorSMTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d27335",
  null
  
)

export default component.exports